module.exports = __webpack_public_path__ + "static/03-44308aec2c4b5851c8a99114bca79f93.jpg";